<!-- Outage Banner Starts -->
<ng-container *ngIf="showOutageBanner">
  <div
    class="outage-banner-component"
    *ngIf="outageBannerComponent$ | async as outageBanner"
  >
    <div class="border-outage-banner">
      <span class="material-icons"> info_outline </span>
      <p
        class="mt-4 mb-0 content-outage-banner"
        [innerHtml]="outageBanner.content"
      ></p>
      <a class="close-outage-banner" (click)="closeOutageBanner()"
        ><span class="material-icons"> close </span></a
      >
    </div>
  </div>
</ng-container>
<!-- End Outage Banner -->
<ng-container *ngIf="user$ | async; else guestLandingPage">
  <!-- <ng-container *ngIf="isUserLoggedIn; else guestLandingPage" #loggedInHomepage> -->
  <ng-container *ngIf="userType == 'current'">
    <vs-loggedin-home-page></vs-loggedin-home-page>
  </ng-container>
  <!-- </ng-container> -->
</ng-container>

<ng-template #guestLandingPage>
  <ng-container *ngIf="userType == 'anonymous'">
    <vs-guest-landing-page></vs-guest-landing-page>
  </ng-container>
</ng-template>
